import ActionTypes from 'store/actionTypes/mentee/interviewLists';
import GetOrderValue from 'types/GetOrderValue';

export type List = 'main';

type SetPage = (
  list: List,
  page: number,
) => { type: ActionTypes; value: number };
export const setPage: SetPage = (list, page) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_INTERVIEWS_SET_PAGE,
        value: page,
      };

    default:
      return {
        type: ActionTypes.MAIN_INTERVIEWS_SET_PAGE,
        value: 0,
      };
  }
};

type SetOrder = <OrderValue extends GetOrderValue<string>>(
  list: List,
  order: OrderValue,
) => { type: ActionTypes; value: OrderValue };
export const setOrder: SetOrder = (list, order) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_INTERVIEWS_SET_ORDER,
        value: order,
      };
    default:
      return {
        type: ActionTypes.MAIN_INTERVIEWS_SET_ORDER,
        value: order,
      };
  }
};
